<template>
  <v-container v-if="!fetching" class="d-flex flex-column justify-center">
    <div v-if="$vuetify.breakpoint.xsOnly" class="mt-2">
      <div class="d-flex justify-space-between align-center">
        <div class="d-flex flex-column">
          <v-btn class="info " small @click="selectAll">
            {{ $t("selectAll") }}
          </v-btn>
          <v-btn class="info mt-2" small @click="removeAll">
            {{ $t("removeAll") }}
          </v-btn>
        </div>

        <div>
          <v-btn class="info" :disabled="disabled" @click="$emit('submit')">
            {{ $t("toSave") }}
          </v-btn>
        </div>
      </div>

      <div class="mt-6">
        <span>{{ $t("allowedBanks") }}</span>
        <v-autocomplete
          v-model="model"
          :items="items"
          :search-input.sync="search"
          :no-data-text="$t('startTypingABank')"
          @change="onBanksChange"
          class="banks"
          persistent-hint
          hide-no-data
          hide-selected
          dense
          multiple
          outlined
          auto-select-first
          chips
          deletable-chips
          append-icon=""
          cache-items
          return-object
        >
          <template v-slot:selection="{ attrs, item, parent }">
            <v-chip v-bind="attrs" color="lighten-3" small class="my-1">
              <span class="pr-1">
                {{ item.text }}
              </span>
              <v-icon small @click="parent.selectItem(item)">
                $delete
              </v-icon>
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </div>
    <div v-else>
      <div>
        <span>{{ $t("allowedBanks") }}</span>
        <v-autocomplete
          v-model="model"
          :items="items"
          :search-input.sync="search"
          :no-data-text="$t('startTypingABank')"
          @change="onBanksChange"
          class="banks"
          persistent-hint
          hide-no-data
          hide-selected
          dense
          multiple
          outlined
          auto-select-first
          chips
          deletable-chips
          append-icon=""
          cache-items
          return-object
        >
          <template v-slot:selection="{ attrs, item, parent }">
            <v-chip v-bind="attrs" color="lighten-3" small class="my-1">
              <span class="pr-1">
                {{ item.text }}
              </span>
              <v-icon small @click="parent.selectItem(item)">
                $delete
              </v-icon>
            </v-chip>
          </template>
        </v-autocomplete>

        <v-card-actions>
          <v-btn class="info" small @click="selectAll">
            {{ $t("selectAll") }}
          </v-btn>
          <v-btn class="info" small @click="removeAll">
            {{ $t("removeAll") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="info"
            small
            :disabled="disabled"
            @click="$emit('submit')"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-container>
  <v-container v-else fill-height fluid>
    <v-row align="center" justify="center">
      <v-col class="d-flex align-center justify-center">
        <v-progress-circular indeterminate color="info"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["selectedBanks", "isDisabled", "dialog"],

  data: () => ({
    model: [],
    items: [],
    core: [],
    search: "",
    fetching: true,
    removed: [],
    disabled: false,
  }),

  watch: {
    isDisabled(bool) {
      this.disabled = bool;
    },
    selectedBanks() {
      this.model = this.selectedBanks;
    },
    dialog(val) {
      if (!val) {
        return;
      }

      this.fetchBanks();
    },
  },

  created() {
    this.fetchBanks();
  },

  methods: {
    fetchBanks() {
      this.model = this.selectedBanks;

      this.$request.get("administrator/bankOperator/listBanks").then((res) => {
        if (!res) {
          this.$emit("closeDialog");
          return;
        }

        this.items = res.dados.map((bank) => ({
          cod_bank: bank.cod_bank,
          text: `${bank.cod_bank} - ${bank.nome_curto}`,
        }));

        this.fetching = false;
      });
    },
    selectAll() {
      this.model = [...this.items];
      this.onBanksChange(this.model);
    },
    removeAll() {
      this.model = [];
      this.onBanksChange(this.model);
    },
    onBanksChange(items) {
      const ids = items.map((bank) => bank.cod_bank);
      this.$emit("onBanksChange", ids);
    },
    filter(item, queryText, itemText) {
      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    },
  },
};
</script>

<style>
.banks .v-select__selections {
  max-height: 300px;
  overflow-y: auto;
}
.v-chip {
  overflow: initial;
}
</style>
